import { Component, ContentChildren, Directive, EventEmitter, Input, OnInit, Output, QueryList } from '@angular/core';

@Directive({
  selector: 'modal-header'
})
export class ModalHeader {

}

@Directive({
  selector: 'modal-content'
})
export class ModalContent {
}

@Directive({
  selector: 'modal-footer'
})
export class ModalFooter {

}

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  @Output() close = new EventEmitter();

  @ContentChildren(ModalHeader, { descendants: true })
  modalHeaderChildren: QueryList<ModalHeader> | null = null;

  @ContentChildren(ModalContent, { descendants: true })
  modalContentChildren: QueryList<ModalContent> | null = null;

  @ContentChildren(ModalFooter, { descendants: true })
  modalFooterChildren: QueryList<ModalFooter> | null = null;

  constructor() { }

  ngOnInit(): void { }

  hasHeader(): boolean {
    return (this != null 
      && this.modalHeaderChildren != null 
      && this.modalHeaderChildren!.length > 0);
  }

  hasFooter(): boolean {
    return (this != null 
      && this.modalFooterChildren != null 
      && this.modalFooterChildren!.length > 0);
  }

  onClose() {
    this.close.emit();
  }
}
